import { Component, Input, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-action-cell-permission-renderer',
  templateUrl: './ag-action-cell-permission-renderer.component.html',
  styleUrls: ['./ag-action-cell-permission-renderer.component.css']
})
export class AgActionCellPermissionRendererComponent implements OnInit, ICellRendererAngularComp {
  public tooltipMessage: string;
  public params: any;
  public isDataPermission = true;
  public isAppPermission = true;
  public isRefresh = false;

  constructor() {}

  ngOnInit() {}

  agInit(params: any): void {
    this.params = params;
    this.updateValues(params);
  }

  refresh(params: any): boolean {
    this.updateValues(params);
    return true;
  }

  private updateValues(params: any) {
    this.isDataPermission = params.isDataPermission;
    this.isAppPermission = params.isAppPermission;
    this.isRefresh = params.isRefresh;
    this.tooltipMessage = params.tooltipMessage;
  }

  departmentPermission() {
    this.params.context.componentParent.departmentPermission(this.params.data);
  }

  accessPermission() {
    this.params.context.componentParent.accessPermission(this.params.data);
  }

  onRefresh() {
    this.params.context.componentParent.onRefresh(this.params.data);
  }
}
